import { _ } from "../../../../core/polyglot/polyglot.js";
import { unique } from "@foretagsplatsen/core-helpers/array";
import GroupRow from "./GroupRow.js";

/**
 * The purpose of `repeatingRow` is to repeat a set of rows
 * accross different dimensions.
 *
 * `repeatingRow` is a group row whose children are clones of each
 * other. Each clone has a different dimension than its original
 * row.
 */
export default class RepeatingRow extends GroupRow {
	constructor() {
		super(...arguments);

		this._cachedOriginalRows = null;
		this._cachedCloneRows = null;
	}

	getTitle() {
		return _("Repeating");
	}

	getDepth() {
		return super.getDepth() - 1;
	}

	getOriginalRows() {
		this._cachedOriginalRows ||= unique(this.getRows(), (row) =>
			row.getTemplate(),
		);

		return this._cachedOriginalRows;
	}

	getCloneRows() {
		if (!this._cachedCloneRows) {
			const originalRows = this.getOriginalRows();

			this._cachedCloneRows = this.getRows().filter(
				(row) => !originalRows.includes(row),
			);
		}

		return this._cachedCloneRows;
	}

	isCloneRow(row) {
		return this.getCloneRows().includes(row);
	}

	canBeCollapsed() {
		return false;
	}

	accept(visitor) {
		return visitor.visitRepeatingRow(this);
	}

	_asBaseFormulaNode() {
		return this._rowsAsFormulaNode(
			this.getRows().filter((row) => this._canRowBeUsedInFormulas(row)),
		);
	}

	_canRowBeUsedInFormulas(row) {
		const originalRow = this._getOriginalRowFromTemplate(row.getTemplate());

		return originalRow?.canBeUsedInFormulas();
	}

	_getOriginalRowFromTemplate(rowTemplate) {
		return this.getOriginalRows().find(
			(originalRow) => originalRow.getTemplate() === rowTemplate,
		);
	}

	static getType() {
		return "RepeatingRow";
	}
}
